import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsMore from "highcharts/highcharts-more.js";
import Exporting from "highcharts/modules/exporting.js";
import ExportData from "highcharts/modules/export-data.js";
import BarChart from "app/components/charts/BarChart";

HighchartsMore(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);

const getSeriesData = (incomeDiffData) => {
  // console.log("incomeDiffData", incomeDiffData);
  let colors = [
    "#DE3E40", // American Indian
    "#6AA4DC", // Hispanic
    "#FB6A59", // Asian and Pacific Islander
    "#FFB607", // African American
    "#70898E", // Two or More Races
    "#005898", // White
  ];

  // Define the desired order
  const order = [
    "American Indian",
    "Hispanic",
    "Asian and Pacific Islander",
    "African American",
    "Two or More Races",
    "White",
  ];

  // Sort incomeDiffData based on the order array
  incomeDiffData.sort((a, b) => {
    return order.indexOf(a.name) - order.indexOf(b.name);
  });

  // Ensure the color array matches the sorted data order
  const orderedColors = order.map((_, i) => colors[i % colors.length]);

  // Map the sorted data to add color and other properties, ensuring color consistency
  return incomeDiffData.map((item, i) => ({
    ...item,
    color: orderedColors[i],
    borderColor: orderedColors[i],
    showInLegend: true,
  }));
};



const IncomeDifferenceChart = (props) => {
  let seriesData = getSeriesData(props.incomeDiffData);
  return (
    <BarChart
      containerId="incomeDiffChart"
      remainingOptions={{
        chart: {
          animation: false,
          type: "bar",
          backgroundColor: "transparent",
          height: 700,
          width: 910,
          spacingTop: 120,
        },

        title: {
          text: "",
          style: {
            color: "#FFF",
            font: "normal normal bold 24px/28px Arial",
          },
          align: "left",
          x: 90,
          margin: 80,
        },

        xAxis: {
          type: "category",
          title: {
            text: "Race",
            style: {
              color: "#fff",
              font: "normal normal normal 18px Arial",
            },
          },
          labels: {
            style: {
              color: "#fff",
              font: "normal normal normal 18px Arial",
            },
          },
        },

        yAxis: {
          gridLineWidth: 0.5,
          title: {
            text: "Median Income",
            style: {
              color: "#fff",
              font: "normal normal normal 18px Arial",
            },
          },
          labels: {
            style: {
              color: "#fff",
              font: "normal normal normal 18px Arial",
            },
            formatter: function() {
              return "$" + (this.value / 1000).toString() + "K";
            },
          },
          maxPadding: 0.2,
          min: 0,
          tickInterval: 20000,
        },
        series: [
          {
            data: seriesData,
          },
        ],
        plotOptions: {
          series: {
            animation: false,
            groupPadding: 20,
            pointWidth: 58,
            pointPadding: 0,
            dataLabels: {
              style: {
                fontSize: "16px",
              },
            },
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          borderRadius: 15,
          borderWidth: 1,
          borderColor: "#707070",
          backgroundColor: "#FFFFFF",
          padding: 17,
          shape: "square",
          style: {
            font: "Arial",
            fontSize: 18,
            color: "#333333",
          },
          formatter() {
            return `Race: <b>${this.key}</b>
                            <br/>Median Income: <b>$${this.y.toLocaleString(
                              "en-US"
                            )}</b>`;
          },
        },
      }}
    />
  );
};

export default IncomeDifferenceChart;
